import { Component, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, mergeMap } from 'rxjs/operators';
import { ModalService } from '../../../core/modal/modal.service';
import { Tariff } from '../tariff.model';
import { BpService } from '../../../core/services/bp.service';
import { MetricsService } from '../../../shared/metrics/metrics.service';
import { PaymentAccountApiService } from '../../../core/modules/payment-account/payment-account-api.service';

export type ActivateSubscriptionState = 'success' | 'notEnoughMoney';

@UntilDestroy()
@Component({
  selector: 'tax-activate-subscription-modal',
  templateUrl: 'activate-subscription-modal.component.html',
  styleUrls: ['activate-subscription-modal.component.sass'],
})
export class ActivateSubscriptionModalComponent {
  @Input() kkmId?: number;
  @Input() tariff?: Tariff;

  isTariffActivated = false;

  constructor(
    private paymentAccountApiService: PaymentAccountApiService,
    private bpService: BpService,
    private metricsService: MetricsService,
    private modalService: ModalService,
  ) {
  }

  get tariffCost(): number | undefined {
    return this.tariff?.periodPrice && this.tariff?.periodUnitsCount
      ? this.tariff.periodPrice * this.tariff.periodUnitsCount
      : undefined;
  }

  activateSubscription(): void {
    this.metricsService.ymGoal('Попытка активации подписки');
    this.paymentAccountApiService.fetchBalance()
      .pipe(
        filter((balance) => {
          if (!this.tariff?.periodPrice || this.tariff.periodPrice > balance.amount) {
            this.closeModal('notEnoughMoney');
            return false;
          }

          return true;
        }),
        mergeMap(() => this.bpService.start('activateKkmMessage', {
          kkmId: this.kkmId,
        })),
        untilDestroyed(this),
      )
      .subscribe({
        next: () => {
          this.metricsService.ymGoal('Подписка активирована');
          this.isTariffActivated = true;
        },
        error: () => {
          this.closeModal();
        },
      });
  }

  closeModal(result?: ActivateSubscriptionState): void {
    this.modalService.close(result);
  }
}
